import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
  type: string;
  data?: any;
  size?: "sm" | "md" | "lg";
  scrollY?: number;
  title?: string | null;
}

const initialState: ModalState = {
  type: "",
  data: null,
  size: "sm",
  scrollY: 0,
  title: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal(state: ModalState, action: PayloadAction<ModalState>) {
      state.type = action.payload.type;
      state.size = action.payload.size;
      state.data = action.payload.data;
      state.title = action.payload.title;
    },
    hideModal(state: ModalState) {
      state.type = "";
      state.data = null;
      state.size = "sm";
      state.title = null;
    },
    setModalType(state: ModalState, action: PayloadAction<ModalState["type"]>) {
      state.type = action.payload;
    },
    setScrollY(state: ModalState, action: PayloadAction<number>) {
      state.scrollY = action.payload;
    },
  },
});

export const { showModal, hideModal, setModalType, setScrollY } =
  modalSlice.actions;

export default modalSlice.reducer;
